import React, { useState } from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { VideoSection } from '../components/VideoSection';
import { Footer } from '../components/Footer';
import { UploadDialog } from '../components/UploadDialog';

export const HomePage = () => {
  const [isUploadOpen, setIsUploadOpen] = useState(false);

  return (
    <div className="min-h-screen">
      <Header onUploadClick={() => setIsUploadOpen(true)} />
      <HeroSection onUploadClick={() => setIsUploadOpen(true)} />
      <FeaturesSection />
      <HowItWorksSection />
      <BenefitsSection />
      <VideoSection />
      <Footer />
      <UploadDialog open={isUploadOpen} onOpenChange={setIsUploadOpen} />
    </div>
  );
};

export default HomePage;
